const FLOW = {
  "PREQUAL": "PREQUAL",
  "DM": "DM",
  "CS": "CS",
  "STANDALONE": "STANDALONE",
  "ACTIVATION_PAYMENT": "ACTIVATION_PAYMENT",
  "PREQUALSTRAIGHT": "PREQUALSTRAIGHT",
  "PREQUALFIT": "PREQUALFIT",
  "CFC": "CFC"
}


const PRODUCT = {
  Grand: { bank: "Grand.bank Plus" },
  Surge: "Surge",
  Reflex: "Reflex",
  Revel: "Revel",
  Fit: "Fit"
}

const BANK = {
  Grand: { bank: "Grand.bank" }
}

export {
  FLOW, PRODUCT, BANK
}; 